// extracted by mini-css-extract-plugin
export default {"main":"styles_main__MO51o","nav":"styles_nav__64i+A","image":"styles_image__MX+gb","email":"styles_email__Zgqyn","table":"styles_table__Izk5l","content":"styles_content__AG-9O"};